import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCached } from '../components/common';

export const useAuthentication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCached.token();
    if (window.location.pathname && token === null && !window.location.pathname.includes('login')) {
      navigate('/login');
    } else if (window.location.pathname && token !== null && window.location.pathname.includes('login')) {
      navigate('/v2');
    }
  }, [navigate]);
};
